import { Feature } from '../models/feature';
import FeatureFlagService from '@assets/js/services/feature-flag';

const CARD_ENTRY_CARDHOLDER_NAME_FEATURE_NAME = 'cardentry-cardholdername';
const CARD_ENTRY_IFRAME_APP = 'cardentry-iframe-app';
const CARD_CVV_ENTRY_IFRAME_APP = 'card-cvventry-iframe-app';
const WEB_WALLETS_SUSPENDED_BLOCKCHAIN_ETHEREUM =
  'web-wallets-suspended-blockchain-ethereum';
const GPAY_FOR_MOB_APP = 'gpay-for-mob-app';
const GPAY_FOR_WEB = 'gpay-for-web';
const ZERO_HASH_USER_AGREEMENT_LINK = 'zero-hash-user-agreement-link';
const NEW_WIDGET_LANDING_PAGE = 'new-widget-landing-page';
const POC_BP_PAYPAL = 'bp-paypal-poc-feature';
const CORPORATE_EXCHANGE_RATES = 'corporate-exchange-rates';

/**
 *  @deprecated now using FeatureFlagService 
 */

export default {
  namespaced: true,
  state: {
    features: [],
  },
  getters: {
    features: state => state.features,
    getFeatureByName: state => name => {
      const feature = state.features.find(feature => feature.name === name);
      if (!feature) {
        return new Feature(false);
      }

      return new Feature(feature.enabled);
    },
    gPayForMobAppFeature: (state, getters) => {
      return getters.getFeatureByName(GPAY_FOR_MOB_APP);
    },
    gPayForWebFeature: (state, getters) => {
      return getters.getFeatureByName(GPAY_FOR_WEB);
    },
    cardholderNameFeature: (state, getters) => {
      return getters.getFeatureByName(CARD_ENTRY_CARDHOLDER_NAME_FEATURE_NAME);
    },
    cardEntryIFrameAppFeature: (state, getters) => {
      return getters.getFeatureByName(CARD_ENTRY_IFRAME_APP);
    },
    cardCvvEntryIFrameAppFeature: (state, getters) => {
      return getters.getFeatureByName(CARD_CVV_ENTRY_IFRAME_APP);
    },
    webWalletsSuspendedBlockchainEthereumFeature: (state, getters) => {
      return getters.getFeatureByName(
        WEB_WALLETS_SUSPENDED_BLOCKCHAIN_ETHEREUM,
      );
    },
    zeroHashLinkFeature: (state, getters) => {
      return getters.getFeatureByName(ZERO_HASH_USER_AGREEMENT_LINK);
    },
    newWidgetLandingPageFeature: (state, getters) => {
      return getters.getFeatureByName(NEW_WIDGET_LANDING_PAGE);
    },
    paypalBPFeature: (state, getters) => {
      return getters.getFeatureByName(POC_BP_PAYPAL);
    },
    corporateExchangeRatesFeature: (state, getters) => {
      return getters.getFeatureByName(CORPORATE_EXCHANGE_RATES);
    },
  },
  mutations: {
    setFeatures(state, payload) {
      state.features = payload;
    },
  },
  actions: {
    async fetchFeatureFlags({ commit }) {
      const { features } = await FeatureFlagService.getUserFeatureFlags();
      return commit('setFeatures', features);
    },
    init ({ dispatch, state }) {
      if (state.features.length > 0) {
        return;
      }
      return dispatch('fetchFeatureFlags');
    }
  }
};
